module.exports = __webpack_public_path__ + "static/media/PIJL_03.3409d110.png";